module.exports = __webpack_public_path__ + "img/logo.5c98d1b8.png";